import disableDefaultFormSubmission from './disableDefaultFormSubmission';
import fetchPopupContent from './fetchPopupContent';
import headerFooterShouldBeOverhauled from './headerFooterShouldBeOverhauled';
import shouldOpenWithoutIframe from './shouldOpenWithoutIframe';

const PopupsService = {
  disableDefaultFormSubmission,
  fetchPopupContent,
  shouldOpenWithoutIframe,
  headerFooterShouldBeOverhauled,
};

export default PopupsService;
